import React from "react";
import kebabCase from "lodash.kebabcase";
import { CtaCard } from "@trussle/external-components";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../../types/IContentfulImage";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { Heading } from "../../Heading";
import { RichText } from "../../RichText";
import { transformRichText } from "../../../helpers/richText";
import { PanelWrapper } from "../../PanelWrapper";

import "./styles.scss";
import { GatsbyImageOrSvg } from "../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface IArticlePanelProps {
  title?: string;
  image?: IContentfulImage & ImageDataLike;
  content?: IContentfulRichTextResponse;
  showCtaCard?: boolean;
}

export const ArticlePanel = (props: IArticlePanelProps) => {
  const transformedProps = {
    ...props,
    content: props.content
      ? transformRichText(props.content.raw)
      : null,
  };
  const {
    image, title, content, showCtaCard,
  } = transformedProps;
  return (
    <PanelWrapper>
      <div
        aria-label="Article panel"
        className="articlePanel"
      >
        <div className="articlePanel__wrapper">
          <div className="articlePanel__article">
            {title && (
            <Heading
              {...(title && {
                id: kebabCase(title.toLowerCase()),
              })}
              className="articlePanel__title"
            >
              {title}
            </Heading>
            )}
            {image && <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} />}
            {content && (
            <RichText
              content={content}
            />
            )}
          </div>
          {
          showCtaCard && (
            <div
              className="articlePanel__children"
            >
              <CtaCard
                heading="Save money with us"
                description="We are an online mortgage service with real advisers"
                ctaText="Get started online"
                link="/get-started"
              />
            </div>
          )
        }
        </div>
      </div>
    </PanelWrapper>
  );
};
